import { type Location, LocationKind, type SchedulingEventType } from '../../../models/Scheduling'

export const DURATION_OPTIONS = [15, 30, 45, 60, 90]

const _KIND_VALUE_PREFIX = 'kind:'

export interface EventTypeLocationOption {
  value: string
  label: string
}

export const buildEventTypeLocationOptions = (
  locations: Location[],
  accountDefaultLocation: Location | undefined,
  userDefaultLocation: Location | undefined,
  selectedEventType?: Pick<SchedulingEventType, 'location'>,
): EventTypeLocationOption[] => {
  const selectedKind = selectedEventType?.location?.kind
  return [
    ...(accountDefaultLocation
      ? [{ value: `${_KIND_VALUE_PREFIX}${LocationKind.ACCOUNT_DEFAULT}`, label: `Account default · Currently: ${accountDefaultLocation.name}` }]
      : selectedKind === LocationKind.ACCOUNT_DEFAULT
        ? [{ value: `${_KIND_VALUE_PREFIX}${LocationKind.ACCOUNT_DEFAULT}`, label: 'Account default · Currently unset' }]
        : []),
    ...(userDefaultLocation
      ? [{ value: `${_KIND_VALUE_PREFIX}${LocationKind.USER_DEFAULT}`, label: `User's default · Currently: ${userDefaultLocation.name}` }]
      : selectedKind === LocationKind.USER_DEFAULT
        ? [{ value: `${_KIND_VALUE_PREFIX}${LocationKind.USER_DEFAULT}`, label: "User's default · Currently unset" }]
        : []),
    ...locations.map((location) => ({ value: location.id, label: location.name })),
  ]
}

export const eventTypeLocationSelectValue = (eventType: Pick<SchedulingEventType, 'location'>): string =>
  eventType.location?.kind === LocationKind.ACCOUNT_DEFAULT || eventType.location?.kind === LocationKind.USER_DEFAULT
    ? `${_KIND_VALUE_PREFIX}${eventType.location.kind}`
    : (eventType.location?.id ?? '')

export const eventTypeLocationPatch = (value: string): Pick<SchedulingEventType, 'location'> =>
  value.startsWith(_KIND_VALUE_PREFIX)
    ? { location: { kind: value.slice(_KIND_VALUE_PREFIX.length) as LocationKind } }
    : { location: value ? { kind: LocationKind.FIXED, id: value } : null }

export const toBookingSlug = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
